import { defineComponent as Z, ref as w, computed as ee, onMounted as te, inject as P, onBeforeUnmount as ne, openBlock as I, createBlock as V, resolveDynamicComponent as j, withCtx as S, normalizeClass as ae, normalizeStyle as se, renderSlot as re } from "vue";
const p = {};
function oe(a, o) {
  p[a] || (p[a] = []), p[a].push(o);
}
function k(a, ...o) {
  p[a] && p[a].forEach((s) => s(...o));
}
const ge = /* @__PURE__ */ Z({
  __name: "HumbleScroll",
  props: {
    animation: { default: "" },
    innerClass: { default: "" },
    variables: { default: void 0 },
    easing: { default: void 0 },
    size: { default: void 0 },
    speed: { default: void 0 },
    once: { type: Boolean, default: void 0 },
    element: { default: "div" },
    innerElement: { default: "div" }
  },
  emits: ["intersecting"],
  setup(a, { emit: o }) {
    const s = a, e = w(null), r = w([]), i = w(), c = w(!1), d = o;
    function m(n) {
      c.value = n, d("intersecting", n);
    }
    const l = ee(() => s.variables ? Object.entries(s.variables).map(([u, y]) => `--hs-${u}: ${y};`).join(" ") : void 0);
    return te(() => {
      r.value = P("humbleElements", []), i.value = P("humbleObserver"), e.value && i.value && r.value && (r.value.push(e.value), i.value.observe(e.value), oe("elementIntersecting", (n) => {
        if (n === e.value) {
          const u = n.className.includes("hs-visible");
          m(u);
        }
      }));
    }), ne(() => {
      if (e.value && i.value && r.value) {
        const n = r.value.indexOf(e.value);
        n !== -1 && (r.value.splice(n, 1), i.value.unobserve(e.value));
      }
    }), (n, u) => (I(), V(j(s.element), {
      ref_key: "element",
      ref: e,
      "data-hs": n.animation,
      "data-hs-easing": n.easing,
      "data-hs-size": n.size,
      "data-hs-speed": n.speed,
      "data-hs-once": n.once
    }, {
      default: S(() => [
        (I(), V(j(n.innerElement), {
          class: ae([n.innerClass]),
          style: se(l.value)
        }, {
          default: S(() => [
            re(n.$slots, "default", { isIntersecting: c.value })
          ]),
          _: 3
        }, 8, ["class", "style"]))
      ]),
      _: 3
    }, 8, ["data-hs", "data-hs-easing", "data-hs-size", "data-hs-speed", "data-hs-once"]));
  }
});
function le(a) {
  return a && a.__esModule && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a;
}
var C = {}, M = {};
(function(a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), Object.defineProperty(a, "default", {
    enumerable: !0,
    get: function() {
      return s;
    }
  });
  function o(e, r) {
    return {
      handler: e,
      config: r
    };
  }
  o.withOptions = function(e, r = () => ({})) {
    const i = function(c) {
      return {
        __options: c,
        handler: e(c),
        config: r(c)
      };
    };
    return i.__isOptionsFunction = !0, i.__pluginFunction = e, i.__configFunction = r, i;
  };
  const s = o;
})(M);
(function(a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), Object.defineProperty(a, "default", {
    enumerable: !0,
    get: function() {
      return e;
    }
  });
  const o = /* @__PURE__ */ s(M);
  function s(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  const e = o.default;
})(C);
let x = C;
var ie = (x.__esModule ? x : { default: x }).default;
const ue = /* @__PURE__ */ le(ie), z = "hs", t = `--${z}`, O = `data-${z}`, E = `${z}-visible`, ce = ["ease-in", "ease-out", "ease-in-out", "ease-out-back"], fe = {
  small: "0.5",
  medium: "0.75",
  large: "2",
  "extra-large": "3"
}, de = {
  "extra-slow": "3",
  slow: "1.5",
  fast: "0.75",
  "extra-fast": "0.5"
};
function _(a, o, s) {
  const e = `${a} * ${o}`;
  return s ? `calc(0px - ${e})` : `calc(${e})`;
}
function me({ addUtilities: a, config: o }) {
  const s = o();
  function e(f, v, g, $) {
    var b;
    const h = {
      [`[${O}${v}='${f}'] > *`]: {
        [g]: $
      }
    };
    if ((b = s == null ? void 0 : s.theme) != null && b.screens)
      for (const [X, Y] of Object.entries(s.theme.screens))
        h[`@media (min-width: ${Y})`] = {
          [`[${O}${v}='${X}:${f}'] > *`]: {
            [g]: $
          }
        };
    return h;
  }
  function r() {
    const f = {};
    return ce.forEach((v) => {
      f[`[${O}-easing*='${v}'] > *`] = {
        [`${t}-easing`]: `var(${t}-${v})`
      };
    }), f;
  }
  function i(f, v, g) {
    const $ = {};
    return Object.entries(v).forEach(([h, b]) => {
      $[`[${O}-${f}~='${h}'] > *`] = {
        [g]: b
      };
    }), $;
  }
  const c = e("up", "~", `${t}-translate-y`, _(`var(${t}-translate-y-amount)`, `var(${t}-translate-ratio)`, !1)), d = e("down", "~", `${t}-translate-y`, _(`var(${t}-translate-y-amount)`, `var(${t}-translate-ratio)`, !0)), m = e("left", "~", `${t}-translate-x`, _(`var(${t}-translate-x-amount)`, `var(${t}-translate-ratio)`, !1)), l = e("right", "~", `${t}-translate-x`, _(`var(${t}-translate-x-amount)`, `var(${t}-translate-ratio)`, !0)), n = e("fade", "*", `${t}-opacity`, "0"), u = e("blur", "*", `${t}-blur`, `${t}-blur-amount`), y = e("zoom-in", "*", `${t}-scale`, `calc(1 + var(${t}-scale-ratio))`), L = e("zoom-out", "*", `${t}-scale`, `calc(1 - var(${t}-scale-ratio))`), D = e("skew-up", "*", `${t}-skew-y`, `var(${t}-skew-amount)`), H = e("skew-down", "*", `${t}-skew-y`, `calc(0deg - var(${t}-skew-amount))`), T = e("skew-right", "*", `${t}-skew-x`, `var(${t}-skew-amount)`), U = e("skew-left", "*", `${t}-skew-x`, `calc(0deg - var(${t}-skew-amount))`), B = e("reveal-up", "*", `${t}-translate-y`, `var(${t}-reveal-amount)`), F = e("reveal-down", "*", `${t}-translate-y`, `calc(0px - var(${t}-reveal-amount))`), N = e("reveal-right", "*", `${t}-translate-x`, `calc(0px - var(${t}-reveal-amount))`), R = e("reveal-left", "*", `${t}-translate-x`, `var(${t}-reveal-amount)`), A = e("flip-up", "*", `${t}-rotate-x`, `var(${t}-flip-x-amount)`), q = e("flip-down", "*", `${t}-rotate-x`, `calc(0deg - var(${t}-flip-x-amount))`), G = e("flip-right", "*", `${t}-rotate-y`, `calc(0deg - var(${t}-flip-y-amount))`), J = e("flip-left", "*", `${t}-rotate-y`, `var(${t}-flip-y-amount)`), K = r(), Q = i("size", fe, `${t}-translate-ratio`), W = i("speed", de, `${t}-duration-ratio`);
  [
    c,
    d,
    m,
    l,
    n,
    u,
    y,
    L,
    D,
    H,
    T,
    U,
    B,
    F,
    N,
    R,
    A,
    q,
    G,
    J,
    K,
    Q,
    W
  ].forEach((f) => a(f));
}
const he = ue(me);
function ve(a = {}) {
  const o = document.documentElement.scrollHeight - document.documentElement.clientHeight, s = {
    root: null,
    threshold: 0.1,
    repeat: !1,
    mirror: !1,
    offset: {
      top: 0,
      right: 0,
      bottom: -40,
      left: 0
    }
  }, e = { ...s, ...a }, r = {
    root: e.root,
    rootMargin: i(e.offset),
    threshold: e.threshold
  };
  function i(m) {
    const l = { ...s.offset, ...m }, n = `${l.top}px ${l.right}px ${l.bottom}px ${l.left}px`, u = `${o}px ${l.right}px ${l.bottom}px ${l.left}px`;
    return e.repeat && !e.mirror ? u : n;
  }
  function c(m) {
    m.forEach((l) => {
      const n = l.target, u = n.getAttribute("data-hs-once");
      if (!e.repeat && l.isIntersecting) {
        n.classList.add(E), k("elementIntersecting", n), d.unobserve(n);
        return;
      }
      if (l.isIntersecting && u && u === "true") {
        n.classList.add(E), d.unobserve(n), k("elementIntersecting", n);
        return;
      }
      n.classList.toggle(E, l.isIntersecting), k("elementIntersecting", n);
    });
  }
  const d = new IntersectionObserver(c, r);
  return {
    intersectionObserver: d
  };
}
const be = {
  install(a, o) {
    if (typeof window > "u" || typeof document > "u")
      return;
    const { intersectionObserver: s } = ve(o), e = [];
    a.provide("humbleElements", e), a.provide("humbleObserver", s);
  }
};
export {
  ge as HumbleScroll,
  he as humbleScrollTailwindPlugin,
  be as humbleScrollVuePlugin
};
